export default __webpack_public_path__ + "img/bandaoti.263d4f3e.svg";